// extracted by mini-css-extract-plugin
export default {"cls1":"ViewsWatcher-cls1___1660a364cfd78796366","cls2":"ViewsWatcher-cls2___39c34ca1d27b5194b98 ViewsWatcher-cls1___1660a364cfd78796366"};